<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button d-flex justify-content-between align-item-center"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
    }"
  >
    <div class="card-token-number text-white">
      <ng-container [ngSwitch]="cardToken?.CardType">
        <img class="card-type-image" *ngSwitchCase="1" src="assets/images/payment-icons/_Mastercard.svg" />
        <img class="card-type-image" *ngSwitchCase="2" src="assets/images/payment-icons/_AMEX.svg" />
        <img class="card-type-image visa" *ngSwitchCase="3" src="assets/images/payment-icons/_Visa.svg" />
        <img class="card-type-image" *ngSwitchCase="4" src="assets/images/payment-icons/_Discover.svg" />
        <img class="card-type-image" *ngSwitchCase="5" src="assets/images/payment-icons/_JCB.svg" />
        <img class="card-type-image" *ngSwitchCase="7" src="assets/images/payment-icons/_DinnersClub.svg" />
        <img class="card-type-image" *ngSwitchCase="8" src="assets/images/payment-icons/_UnionPay.svg" />
        <div class="card-type-image" *ngSwitchDefault></div>
      </ng-container>

      ({{ cardToken.CardNumber.substr(12) }})

      <!-- <div class="payment-status text-success" *ngIf="!cardToken.Frozen">{{ 'member.card.ecash.active' | translate }}</div>
      <div class="payment-status text-white frozen-status" *ngIf="cardToken.Frozen">
        {{ 'member.card.ecash.frozen' | translate }}
      </div> -->
    </div>

    <a class="d-flex text-white" [ngClass]="{ 'text-white': cardToken.Frozen }" [routerLink]="'/payment'">
      <span class="icon material-icons text-white">chevron_right</span>
    </a>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="ecash-button">
    <a class="btn d-flex align-item-center justify-content-center text-white" [routerLink]="'/payment'">
      <span class="icon material-icons pe-2">add_card</span>
      <span class="font-size-14 add-card-text">{{ 'member.card.ecash.add' | translate }}</span>
    </a>
  </div>
</ng-template>
